import { useEffect, useRef, useState, useCallback, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-calendar/dist/Calendar.css";
import Calendar from "react-calendar";
import {
  faFloppyDisk,
  faMoneyCheckDollar,
} from "@fortawesome/free-solid-svg-icons";
import EditingMainHeader from "../../components/addOns/headers/EditingMainHeader";
import { GetApiContext } from "../../context/apiCalls/getApiCalls";
import { useAuthState } from "../../context/authContext";
import { PostApiContext } from "../../context/apiCalls/postApiCalls";
import { PdfContext } from "../../context/PdfContext";
import Loader from "../../components/addOns/loader";
import { getCurrentDate } from "../../utils/utils";
import ContactInfosPanel from "../../components/customer/editingPages/informations/ContactInfosPanel";
import { PopupContext } from "../../context/PopupContext";
import DepositInputs from "../../components/customer/deposit/DepositInputs";
import Total from "../../components/customer/invoices/invoice/recap/total";
import { AppContext } from "../../context/appContext";
import MailPop from "../../components/addOns/MailPop";
import { toast } from "react-toastify";

export default function Deposit({ depositId, setRefresh }) {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();

  const idPage = useLocation().pathname.split("/")[2].split("-")[0];
  const locationId = useLocation().pathname.split("/")[3].split("-")[0];
  // Correction : prioriser depositId si fourni, sinon fallback sur locationId
  let id = depositId ? depositId : locationId;
  const getApiContext = useContext(GetApiContext);
  let postApiContext = useContext(PostApiContext);
  const pdfContext = useContext(PdfContext);
  const { roleId } = useAuthState();
  const { popups, setPopupVisibility } = useContext(PopupContext);

  // Ref
  const [ref, setRef] = useState("");
  const refRef = useRef("");
  const rateRef = useRef(null);
  const totalTTCRef = useRef(null);
  const titleRef = useRef(null);
  const descRef = useRef(null);
  const dateRef = useRef(null);
  let oldId = useRef(null);

  // State
  const [depositDate, setDepositDate] = useState(null);
  const [payementDate, setPayementDate] = useState(null);
  const [calendarPop, setCalendarPop] = useState(false);
  const [buttonId, setbuttonId] = useState(null);
  const [data, setData] = useState(undefined);
  const [dataContact, setDataContact] = useState(null);
  const [dataQuoteInvoice, setDataQuoteInvoice] = useState(null);
  const [quote, setQuote] = useState(null);
  const [invoice, setInvoice] = useState(null);
  const [totalTtc, setTotalTtc] = useState(0);
  const [showCalendar, setShowCalendar] = useState(false);
  const [loading, setLoading] = useState(true);

  const [rate, setRate] = useState("");
  const [linkDeposit, setLinkDeposit] = useState([]);
  const [totalLinkDeposit, setTotalLinkDeposit] = useState(0);
  const [leftToPay, setLeftToPay] = useState(null);
  const [depositTotalTtc, setDepositTotalTtc] = useState(0);
  const [calc, setCalc] = useState(null);

  const fetchDepositData = useCallback(async () => {
    try {
      if (!(id === oldId.current)) {
        oldId.current = id;
        setLoading(true);
        let idQuote = null;
        let idInvoice = null;
        let idDeposit = null;

        if (depositId) {
          idDeposit = depositId;
        } else if (idPage === "quote") {
          idQuote = id;
        } else if (idPage === "invoice") {
          idInvoice = id;
        } else {
          idDeposit = id;
        }

        getApiContext
          .getDeposit(depositId ?? idDeposit, "", idQuote, idInvoice)
          .then((response) => {
            const depositData = response?.deposit?.deposit || null;
            setData(depositData);
            setRef(depositData?.ref || "");
            setInvoice(depositData?.invoice || null);
            setQuote(depositData?.quote || null);
            setDataQuoteInvoice(
              depositData?.invoice || depositData?.quote || null
            );
            setLinkDeposit(response?.linkDeposit);
            setLoading(false);
            dateRef.current = depositData?.depositDate || getCurrentDate();
          });
      }
    } catch (error) {
      console.error(error);
    }
  }, [getApiContext, id, idPage, depositId]);

  useEffect(() => {
    fetchDepositData();
  }, [fetchDepositData]);

  useEffect(() => {
    setTotalTtc(
      invoice?.totalTtc ??
        quote?.totalTtc ??
        data?.quote?.totalTtc ??
        data?.totalTtc ??
        0
    );
    const totalLinkDepositMap =
      linkDeposit?.map((element) => element.totalTtc) ?? [];
    const sommeTotalTtc = totalLinkDepositMap
      .map(Number)
      .reduce((a, b) => a + b, 0);
    setTotalLinkDeposit(sommeTotalTtc);

    setCalc(totalTtc - sommeTotalTtc);
    setLeftToPay(totalTtc - sommeTotalTtc);

    setRate(data?.rate ?? 0);
    setDepositTotalTtc(data?.totalTtc ?? 0);

    if (totalTtc?.toString() === "0") {
      const rateData = data?.deposit?.rate;
      const calcTtc = (rateData * calc) / 100;
      setDepositTotalTtc(calcTtc?.toFixed(2));
    }

    if (!dataContact) {
      setDataContact(data?.quote?.contact ?? data?.invoice?.contact ?? null);
    }
  }, [data, quote, invoice, linkDeposit, id, totalTtc, dataContact, calc]);

  const handleCalc = (e) => {
    e.preventDefault();
    if (e.target.id === "totalDepositInput") {
      // Correction : retirer l'ancien montant de l'acompte courant de la somme des acomptes déjà versés
      const oldDeposit = Number(data?.totalTtc || 0);
      const totalLinkDepositWithoutCurrent = totalLinkDeposit - oldDeposit;
      const newDeposit = Number(e.target.value);
      const totalCalc = totalTtc - totalLinkDepositWithoutCurrent - newDeposit;
      const rateCalc = (newDeposit / totalTtc) * 100;
      setRate(rateCalc.toFixed(2) || "");
      setLeftToPay(totalCalc);
      setDepositTotalTtc(e.target.value);
    } else if (e.target.id === "rateInput") {
      // Correction : permettre le champ vide
      if (e.target.value === "") {
        setRate("");
        setDepositTotalTtc("");
        setLeftToPay(totalTtc);
      } else {
        const oldDeposit = Number(data?.totalTtc || 0);
        const totalLinkDepositWithoutCurrent = totalLinkDeposit - oldDeposit;
        const rateValue = Number(e.target.value);
        const rateCalc = (totalTtc * rateValue) / 100;
        const totalCalc = totalTtc - totalLinkDepositWithoutCurrent - rateCalc;
        setRate(rateValue);
        setDepositTotalTtc(rateCalc?.toFixed(2));
        setLeftToPay(totalCalc);
      }
    }
  };

  const onSubmit = (e) => {
    //console.log("deposit submit")
    let path =
      idPage === "quote"
        ? `/quotesList/quote/${quote?.id}`
        : idPage === "invoice"
        ? `/invoicesList/invoice/${invoice?.id}`
        : "/depositsList/";
    onValidDeposit(e, path);
    fetchDepositData();
  };

  const onValidDeposit = (
    e,
    path = `/depositsList/deposit/${
      localStorage.getItem("parentPath").includes("invoice")
        ? invoice?.id
        : quote?.id
    }-${
      localStorage.getItem("parentPath").includes("invoice")
        ? "invoice"
        : "quote"
    }`
  ) => {
    e?.preventDefault();

    // Empêcher la validation si le montant ou le taux est négatif
    if (
      parseFloat(totalTTCRef.current.value) < 0 ||
      parseFloat(rateRef.current.value) < 0
    ) {
      toast.error("Le montant ou le taux de l'acompte ne peut pas être négatif");
      return;
    }

    const values = {
      idDeposit: data?.id ?? null,
      idQuote: data?.quote?.id || (idPage === "quote" ? id : null),
      idInvoice: data?.invoice?.id || (idPage === "invoice" ? id : null),
      ref: refRef.current.value,
      depositDate: dateRef.current ?? depositDate,
      paymentDate: payementDate ? payementDate : data?.paymentDate,
      // Correction : si le champ est vide, sauvegarder 0
      rate: rate === "" ? 0 : rateRef.current.value,
      totalTTC: totalTTCRef.current.value,
      subject: titleRef?.current?.value,
      comment: descRef?.current?.value,
    };

    postApiContext
      .postDeposit(values)
      .then((response) => {
        response.status === "success" ? toast.success("L'acompte a bien été enregistré") : toast.error("Une erreur est survenue lors de l'enregistrement de l'acompte");
        fetchDepositData();
        handleNavigate(path);
        if (setRefresh) {
          setRefresh(true);
        }
        setPopupVisibility("showDepositPopup", false);
        // window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleNavigate = (path = "") => {
    let newPath = localStorage.getItem("parentPath");
    navigate(newPath ?? path ?? "/depositsList");
  };

  function handleNavigateFunc(path = "") {
    let newPath = localStorage.getItem("parentPath");
    return newPath ?? path ?? "/depositsList";
  }

  // const handleDelete = (depositId) => {
  //     //e.preventDefault()
  //     console.log("delete", depositId)
  //     postApiContext.desactivateDeposit(depositId)
  //         .then(response => {
  //             fetchDepositData();
  //             window.location.reload();
  //         })
  //     if (depositId === id) {
  //         navigate(handleNavigateFunc())
  //     }
  // }

  const filterDate = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}-${month}-${day}`;
  };

  const handleClick = (e) => {
    const id = e.target.id;
    if (id === "depositDate") {
      setCalendarPop(true);
      setbuttonId("1");
    } else if (id === "payementDate") {
      setCalendarPop(true);
      setbuttonId("2");
    }
  };

  const handleChange = (e) => {
    if (buttonId === "1") {
      setDepositDate(filterDate(e));
    } else {
      setPayementDate(filterDate(e));
    }
  };

  const duplicateDeposit = (e) => {
    onValidDeposit(e, "");
    const dupId = data?.id;
    getApiContext.getDeposit("", dupId).then((response) => {
      if (response?.data) {
        const deposit = response.data.deposit;
        navigate(`/depositsList/deposit/${deposit?.id}`);
      }
    });
  };

  const headerButtonsList = {
    dropdown: {
      telecharger: {
        content: "Télécharger",
        handleClick: () => pdfContext.handlePDF("deposit", id, false),
        redir: false,
      },
      imprimer: {
        content: "Imprimer",
        handleClick: () => pdfContext.handlePDF("deposit", id, true),
        redir: false,
      },
      envoyer: {
        content: "Envoyer",
        handleClick: () => {
          appContext.setShowMailPop(true);
        },
        redir: false,
      },
      dupliquer: {
        content: "Dupliquer",
        handleClick: () => {duplicateDeposit()},
        redir: false,
      },
    },
    mainButton: {
      buttonIcon: faFloppyDisk,
      buttonText: id ? "Sauvegarder" : "Créer l'acompte",
      buttonAction: (e) => onValidDeposit(e, handleNavigateFunc()),
      className: "hide-text-650"
    },
  };

  return (
    <>
      <MailPop
        endpoint={"c-deposit-send-email"}
        id={id}
        itemName={"Acompte"}
        title={refRef?.current?.value}
      />
      {(loading || pdfContext.loading) && <Loader />}
      {calendarPop && (
        <div onClick={() => setCalendarPop(false)} className="grayBlur"></div>
      )}
      {calendarPop && (
        <>
          <Calendar onChange={handleChange} />
        </>
      )}
      <EditingMainHeader
        headerTitle={"Acompte"}
        dateRef={dateRef}
        setShowCalendar={setShowCalendar}
        showCalendar={showCalendar}
        destination={handleNavigateFunc()}
        endPoint={"c-deactive-deposit"}
        id={id}
        refRef={refRef}
        defaultRef={ref}
        roleId={roleId}
        headerButtonsList={headerButtonsList}
        backRedirect={popups.showDepositPopup ? null : "/depositsList"}
      />

      <form onSubmit={onSubmit} className="listPage">
        <div className="block">
          <div className="editingInfos">
            <div className="editingInfos__titleContainer">
              <h2 className="editingInfos__titleContainer_title">
                informations
              </h2>
              <hr className="editingInfos__titleContainer_line" />
            </div>
            <div className="editingInfos__firstSection">
              <div className="editingInfos__firstSection_nameContainer">
                <h3 className="editingInfos__firstSection_nameContainer_title">
                  Intitulé de l'acompte
                </h3>
                <input
                  className={"editingInfos__firstSection_nameContainer_input"}
                  defaultValue={data?.subject}
                  ref={titleRef}
                  placeholder="Intitulé"
                />
              </div>
              <div className="editingInfos__firstSection_interContainer">
                <h3 className="editingInfos__firstSection_interContainer_title">
                  {data?.quote
                    ? "Référence du devis"
                    : "Référence de la facture"}
                </h3>
                <div className="editingInfos__firstSection_interContainer_content">
                  <input
                    className={"editingInfos__firstSection_nameContainer_input"}
                    value={
                      (data?.quote ? "Devis" : "Facture") +
                      "N°" +
                      dataQuoteInvoice?.ref
                    }
                    readOnly
                  />
                </div>
              </div>
            </div>
            <ContactInfosPanel
              contact={dataContact}
              customClass={"contactInfoPanelw-0-5"}
            />
          </div>
          <div className="contract-body">
            <div className="container">
              <DepositInputs
                rateRef={rateRef}
                totalTTCRef={totalTTCRef}
                rate={rate === 0 ? "" : rate}
                depositTotalTtc={depositTotalTtc}
                handleCalc={handleCalc}
              />
              <div className="comment">
                <h3>COMMENTAIRE AJOUTE A L'ACOMPTE</h3>
                <hr className="comment line" />
                <textarea
                  ref={descRef}
                  defaultValue={data?.comment}
                  placeholder="Description"
                ></textarea>
              </div>
            </div>
          </div>
          <div className="aside">
            <div className="priceRecap">
              <Total
                title={data?.quote ? "Total TTC du devis" : "Total TTC de la facture"}
                price={`${parseFloat(totalTtc).toFixed(2)}`}
              />
              <Total
                title="Total de l'acompte"
                price={`${isNaN(Number(depositTotalTtc)) ? "0.00" : Number(depositTotalTtc).toFixed(2)}`}
              />
              <div className="marginPrice__tva">
                <div>
                  <p>Total des acomptes</p>
                  <p className="depositTvaAmount">
                    {totalLinkDeposit.toFixed(2) || 0} €
                  </p>
                </div>
              </div>
              <Total
                title={data?.quote ? "Reste du devis à payer" : "Reste de la facture à payer"}
                price={`${parseFloat(leftToPay || "0").toFixed(2)}`}
              />
              <div className="payementDate">
                <p>
                  <FontAwesomeIcon icon={faMoneyCheckDollar} />
                  Suivi de règlement :
                </p>
                <div>
                  Acompte payé le
                  <p className="calendarLogoBg " onClick={handleClick}>
                    <img
                      className="calendarLogo"
                      id="payementDate"
                      src="/calendar-days-solid.svg"
                      alt=""
                    />
                  </p>
                  <span>
                    &thinsp;&thinsp;&thinsp;
                    {payementDate ? payementDate : data?.paymentDate}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}
